import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Features from './pages/Features';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import Download from './pages/Download';
import HowToUse from './pages/HowToUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import LegalNotice from './pages/LegalNotice';
import TermsOfService from './pages/TermsOfService';
import CopyrightNotice from './pages/CopyrightNotice';
import WhyRedCloud from './pages/WhyRedCloud';
import OwnershipTransfer from './pages/OwnershipTransfer';
import moonBg from './images/moon-bg.png';
import './App.css';

const AppContainer = styled.div`
  min-height: 100vh;
  width: 100vw;
  background-image: url(${moonBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  overflow-x: hidden;
  position: relative;
  
  @media (max-width: 768px) {
    background-attachment: scroll;
  }
`;

const Cloud = styled(motion.div)`
  position: fixed;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  background-image: url('/images/cloud-icon.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  filter: drop-shadow(0 0 10px rgba(255, 0, 0, 0.2));
  pointer-events: none;
  z-index: 1;
`;

const App = () => {
  const clouds = Array(12).fill(null).map(() => ({
    size: Math.random() * 40 + 30,
    x: Math.random() * 80 + 10,
    y: Math.random() * 70 + 10,
    duration: 3 + Math.random() * 2,
    delay: Math.random() * 10,
  }));

  return (
    <Router>
      <ScrollToTop />
      <AppContainer>
        {clouds.map((cloud, i) => (
          <Cloud
            key={i}
            size={cloud.size}
            style={{
              left: `${cloud.x}%`,
              top: `${cloud.y}%`,
            }}
            animate={{
              opacity: [0, 0.6, 0],
            }}
            transition={{
              duration: cloud.duration,
              repeat: Infinity,
              repeatDelay: cloud.delay,
              ease: "easeInOut",
            }}
            initial={{ opacity: 0 }}
          />
        ))}
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/features" element={<Features />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/download" element={<Download />} />
            <Route path="/how-to-use" element={<HowToUse />} />
            <Route path="/why-redcloud" element={<WhyRedCloud />} />
            <Route path="/why-choose-redcloud" element={<WhyRedCloud />} />
            <Route path="/ownership-transfer" element={<OwnershipTransfer />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/legal" element={<LegalNotice />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/copyright" element={<CopyrightNotice />} />
          </Routes>
        </Layout>
      </AppContainer>
    </Router>
  );
};

export default App;
